import React from 'react';

const CloseIcon = () => (
  <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M31 1.82371L29.2029 0.0305176L15.5 13.7072L1.79709 0.0305176L0 1.82371L13.7029 15.5005L0 29.1763L1.79709 30.9694L15.5 17.2937L29.2029 30.9694L31 29.1763L17.2961 15.5005L31 1.82371Z" fill="#A9AEB9"/>
  </svg>
);

export default CloseIcon;
